<template>
    <div>
        <div style="display: flex;justify-content: center;">
            <h1>Excel批量导入</h1>
        </div>
        <div style=" display: flex;justify-content: center;align-items: center;">
            <div>
                <div style="margin-bottom: 30px;border: 1px solid #577BB5;border-radius: 5px;padding: 10px;">
                    <h3>下载Excel模板</h3>
                    <div style="font-size: 15px;">点击下方按钮下载Excel模板文件到本地：</div>
                    <div style="font-size: 13px;color: gray;">1.模板已预设好正确的数据格式和列标题</div>
                    <div style="font-size: 13px;color: gray;">2.请勿修改模板中的表头结构和必填字段</div>
                    <div style="display: flex;justify-content: center;margin-top: 15px;">
                        <van-button icon="down" round plain type="primary" @click="downloadExcel">下载Excel文件</van-button>

                    </div>

                </div>
                <div style="border: 1px solid lightgray;border-radius: 5px;padding: 15px;">
                    <h3>上传Excel文件</h3>
                    <div style="font-size: 15px;">点击下方按钮上传Excel文件到服务器：</div>
                    <div style="font-size: 13px;color: gray;">1.请确保您上传的文件是基于我们提供的模板修改的</div>
                    <div style="font-size: 13px;color: gray;">2.请确保您上传的文件格式正确</div>
                    <div style="font-size: 13px;color: gray;">3.请确保您上传的文件包含完整的数据记录</div>
                    <div style="display: flex;justify-content: center;margin-top: 15px;">
                        <van-uploader v-model="fileList" :after-read="uploadFile" accept=".xlsx,.xls,.csv"
                            :max-size="5 * 1024 * 1024" @oversize="onOversize" :preview-image="false">
                            <van-button icon="plus" round type="success">上传Excel文件</van-button>
                        </van-uploader>

                    </div>
                    <div v-if="fileName != ''" style="color: gray;font-size: 12px;margin-top: 10px;">
                        已成功上传文件：{{ fileName }}
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>

export default {
    data: () => ({
        fileList: [],
        fileName: ''
    }),
    methods: {
        downloadExcel() {
            const link = document.createElement('a');
            link.href = 'https://mapi.cdydkj.cn/public/img/batch.xlsx';
            link.download = 'batch.xlsx';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async uploadFile(file) {
            const formData = new FormData();
            formData.append('file', file.file);
            try {
                const response = await fetch('https://mapi.cdydkj.cn/admin/Orderbulk/batchImport', {
                    method: 'POST',
                    body: formData
                });

                if (!response.ok) throw new Error('上传失败');

                const result = await response.json();
                this.$toast(result.msg);
                if (result.code == 1) {
                    this.fileName = file.file.name

                }

                console.log('服务器返回:', result);
            } catch (error) {
                this.$toast('上传失败: ' + error.message);
            }
        },

        onOversize() {
            this.$toast('文件大小不能超过5MB');
        }
    }
};
</script>

<style scoped lang="less"></style>
